import { render, staticRenderFns } from "./strategy_task.vue?vue&type=template&id=9a3b360a"
import script from "./strategy_task.vue?vue&type=script&lang=js"
export * from "./strategy_task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports